import { Link, useNavigate } from "react-router-dom";
import {
  ChatSvg,
  CloseSvg,
  EditnewSvg,
  EditSvg,
  NotificationsSvg,
  StarSvg,
} from "../../svgFile";
import { defaultConfig } from "../../config";
import { usePage } from "../../PageContext";

const AllMenu = ({ count = 0 }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("userData"));
  const { setProfilePhoto } = usePage();
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    setProfilePhoto(null);
    const offcanvasEl = document.getElementById("mainMenu");

    if (offcanvasEl) {
      let offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
      if (!offcanvas) offcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
      offcanvas.hide();
    }
  };
  const handleProfileClick = () => {
    if (token) {
      const offcanvasEl = document.getElementById("mainMenu");
      if (offcanvasEl) {
        let offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (!offcanvas) offcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
        offcanvas.hide();
      }
      navigate("/myprofile");
    }
  };

  const handleNavAndClose = (path) => {
    const offcanvasEl = document.getElementById("mainMenu");
    if (offcanvasEl) {
      let offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
      if (!offcanvas) offcanvas = new window.bootstrap.Offcanvas(offcanvasEl);
      offcanvas.hide();
    }
    navigate(path);
  };
  const { profilePhoto } = usePage();
  const isInstalled = localStorage.getItem("appInstalled") === "true";

  return (
    <div
      className="offcanvas offcanvas-start sidebar-offcanvas"
      tabIndex="-1"
      id="mainMenu"
      aria-label="Main Menu"
    >
      <div className="offcanvas-header d-xl-none d-flex justify-content-end">
        <button
          type="button"
          className="sidebar-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <CloseSvg />
        </button>
      </div>

      {/* ✅ Same menu works for desktop & mobile */}
      <div className="offcanvas-body p-0 p-lg-0">
        <div className="sidebar-profile mx-auto text-center d-xl-none">
          <div
            className="s-pimg position-relative"
            onClick={handleProfileClick}
          >
            <img
              src={
                profilePhoto
                  ? defaultConfig.Userimage + profilePhoto
                  : "/image/profile.png"
              }
              alt=""
            />
            {token && (
              <label className="my-edit" style={{ cursor: "pointer" }}>
                <EditSvg />
              </label>
            )}
          </div>
          <div className="side-p-content">
            <p className="mb-2">Welcome</p>
            {token ? (
              <h3>{user?.full_name}</h3>
            ) : (
              <h3>
                <span>
                  <Link
                    to="/signin"
                    onClick={(e) => {
                      e.preventDefault(); // prevent default to avoid race/double navigation
                      handleNavAndClose("/signin");
                    }}
                  >
                    Login
                  </Link>
                </span>
                /
                <span>
                  <Link
                    to="/signup"
                    onClick={(e) => {
                      e.preventDefault(); // prevent default to avoid race/double navigation
                      handleNavAndClose("/signup");
                    }}
                  >
                    SignUp
                  </Link>
                </span>
              </h3>
            )}

            <div className="d-flex align-items-center gap-3 justify-content-center mt-3">
              {token && user?.role === "Player" && (
                <>
                  <button
                    className="pr-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose(token ? "/profile/skill" : "/signin");
                    }}
                  >
                    <StarSvg />
                  </button>
                  <button
                    className="pr-icon"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavAndClose(token ? "/notes" : "/signin");
                    }}
                  >
                    <EditnewSvg />
                  </button>
                </>
              )}
              {token && (
                <button
                  className="pr-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/chats" : "/signin");
                  }}
                >
                  <ChatSvg />
                </button>
              )}
              {token && (
                <button
                  className="pr-icon position-relative"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/notification" : "/signin");
                  }}
                >
                  <NotificationsSvg />{" "}
                  <span className="notification-dot ">{count}</span>
                </button>
              )}
            </div>
          </div>
        </div>

        <ul className="navbar-nav ms-auto mb-lg-0 p-4 p-lg-0 d-flex header-menu">
          {!isInstalled && (
            <li className="nav-item">
              <Link
                className="nav-link"
                to="/install-app"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavAndClose("/install-app");
                }}
              >
                <span className="menu-icon me-3">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="7"
                      y="2"
                      width="10"
                      height="20"
                      rx="2"
                      stroke="#69F675"
                      strokeWidth="1.8"
                    />

                    <path
                      d="M12 7V13"
                      stroke="#69F675"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />

                    <path
                      d="M9.5 10.5L12 13L14.5 10.5"
                      stroke="#69F675"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />

                    <circle cx="12" cy="18" r="1" fill="#69F675" />
                  </svg>
                </span>
                Install App
              </Link>
            </li>
          )}
          {/* <li className="nav-item">
            <Link
              className="nav-link"
              to="/"
              onClick={(e) => {
                e.preventDefault(); 
                handleNavAndClose("/");
              }}
            >
              <span className="menu-icon me-3">
                <img src="/image/Home.svg" alt="" />
              </span>
              Home
            </Link>
          </li> */}
          {token && user?.role === "Coach" && (
            <>
              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/player-invitation" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/player-invitation" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/invitation.png" alt="" />
                  </span>
                  Player Invitation
                </Link>
              </li>
              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/coaches-summary" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/coaches-summary" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/skillsvg.svg" alt="" />
                  </span>
                 Coaches Summary
                </Link>
              </li>
            </>
          )}
          {(!token || user?.role === "Player") && (
            <>
              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/personal-training" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/personal-training" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/training.svg" alt="" />
                  </span>
                  Personal Training Session
                </Link>
              </li>
              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/profile/skill" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/profile/skill" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/skillsvg.svg" alt="" />
                  </span>
                  My Skills
                </Link>
              </li>
              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/allocated-training" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(
                      token ? "/allocated-training" : "/signin",
                    );
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/allocated.svg" alt="" />
                  </span>
                  Coaches Training
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={token ? "/trophy-room" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/trophy-room" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/trophy.svg" alt="" />
                  </span>
                  Trophy Room
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to={token ? "/subscription" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/subscription" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/subscription.svg" alt="" />
                  </span>
                  Subscription Options
                </Link>
              </li>

              <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/invitation" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/invitation" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/invitation.png" alt="" />
                  </span>
                  Coach Invitation
                </Link>
              </li>
              {/* <li className="nav-item d-xl-none d-block">
                <Link
                  className="nav-link"
                  to={token ? "/payment-history" : "/signin"}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavAndClose(token ? "/payment-history" : "/signin");
                  }}
                >
                  <span className="menu-icon me-3">
                    <img src="/image/paymenthistory.png" alt="" />
                  </span>
                 Transaction History
                </Link>
              </li> */}
            </>
          )}

          <li className="nav-item">
            <Link
              className="nav-link"
              to="/setting"
              onClick={(e) => {
                e.preventDefault();
                handleNavAndClose("/setting");
              }}
            >
              <span className="menu-icon me-3">
                <img src="/image/setting.svg" alt="" />
              </span>
              App Settings
            </Link>
          </li>
          <li className="nav-item d-xl-none d-block">
            <Link
              className="nav-link"
              to="/contact"
              onClick={(e) => {
                e.preventDefault();
                handleNavAndClose("/contact");
              }}
            >
              <span className="menu-icon me-3">
                <img src="/image/Phone.svg" alt="" />
              </span>
              Contact Us
            </Link>
          </li>
          {token && (
            <li className="nav-item d-xl-none d-block">
              <Link className="nav-link" to="/signin" onClick={handleLogout}>
                <span className="menu-icon me-3">
                  <img src="/image/logout.svg" alt="" />
                </span>
                Logout
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AllMenu;
